import { render, staticRenderFns } from "./customize-sample-order.vue?vue&type=template&id=5826fcdc&scoped=true"
import script from "./customize-sample-order.vue?vue&type=script&lang=js"
export * from "./customize-sample-order.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5826fcdc",
  null
  
)

export default component.exports